export default {
  eoCampaignProspects: {
    title: 'Prospects',
    subtitle: 'Connect an existing Drip list to campaign or create new one and import prospects.',
    eoDripList: {
      label: 'Select Drip list',
    },
  },
};
